/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CandidateContactLogCreate } from '../models/CandidateContactLogCreate'
import type { CandidateContactLogPatch } from '../models/CandidateContactLogPatch'
import type { CarePartnerContactLogCreate } from '../models/CarePartnerContactLogCreate'
import type { CarePartnerContactLogPatch } from '../models/CarePartnerContactLogPatch'
import type { ContactLogResponse } from '../models/ContactLogResponse'
import type { PatientContactLogCreate } from '../models/PatientContactLogCreate'
import type { PatientContactLogPatch } from '../models/PatientContactLogPatch'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenContactLogsService {
    /**
     * List Patient Contact Attempts
     * List all contact attempts for a patient, including attempts from matching candidates.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static listPatientContactAttemptsPatientPatientIdContactLogsGet({
        patientId
    }: {
        patientId: string
    }): CancelablePromise<Array<ContactLogResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/patient/{patient_id}/contact_logs',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create Patient Contact Attempt
     * Create a new contact attempt for a patient.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static createPatientContactAttemptPatientPatientIdContactLogsPost({
        patientId,
        requestBody
    }: {
        patientId: string
        requestBody: PatientContactLogCreate
    }): CancelablePromise<ContactLogResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/patient/{patient_id}/contact_logs',
            path: {
                patient_id: patientId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Patient Contact Attempt
     * Update a patient contact attempt.
     * Automatically logs all field changes to the audit trail.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static updatePatientContactAttemptPatientPatientIdContactLogsContactAttemptIdPatch({
        patientId,
        contactAttemptId,
        requestBody
    }: {
        patientId: string
        contactAttemptId: string
        requestBody: PatientContactLogPatch
    }): CancelablePromise<ContactLogResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/patient/{patient_id}/contact_logs/{contact_attempt_id}',
            path: {
                patient_id: patientId,
                contact_attempt_id: contactAttemptId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * List Candidate Contact Attempts
     * List all contact attempts for a candidate, including attempts from matching patients.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static listCandidateContactAttemptsCandidateCandidateIdContactLogsGet({
        candidateId
    }: {
        candidateId: string
    }): CancelablePromise<Array<ContactLogResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/candidate/{candidate_id}/contact_logs',
            path: {
                candidate_id: candidateId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create Candidate Contact Attempt
     * Create a new contact attempt for a candidate.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static createCandidateContactAttemptCandidateCandidateIdContactLogsPost({
        candidateId,
        requestBody
    }: {
        candidateId: string
        requestBody: CandidateContactLogCreate
    }): CancelablePromise<ContactLogResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/candidate/{candidate_id}/contact_logs',
            path: {
                candidate_id: candidateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Candidate Contact Attempt
     * Update a candidate contact attempt.
     * Automatically logs all field changes to the audit trail.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static updateCandidateContactAttemptCandidateCandidateIdContactLogsContactAttemptIdPatch({
        candidateId,
        contactAttemptId,
        requestBody
    }: {
        candidateId: string
        contactAttemptId: string
        requestBody: CandidateContactLogPatch
    }): CancelablePromise<ContactLogResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/candidate/{candidate_id}/contact_logs/{contact_attempt_id}',
            path: {
                candidate_id: candidateId,
                contact_attempt_id: contactAttemptId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * List Care Partner Contact Attempts
     * List all contact attempts for a care partner.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static listCarePartnerContactAttemptsCarePartnerCarePartnerIdContactLogsGet({
        carePartnerId
    }: {
        carePartnerId: string
    }): CancelablePromise<Array<ContactLogResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/care_partner/{care_partner_id}/contact_logs',
            path: {
                care_partner_id: carePartnerId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create Care Partner Contact Attempt
     * Create a new contact attempt for a care partner.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static createCarePartnerContactAttemptCarePartnerCarePartnerIdContactLogsPost({
        carePartnerId,
        requestBody
    }: {
        carePartnerId: string
        requestBody: CarePartnerContactLogCreate
    }): CancelablePromise<ContactLogResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/care_partner/{care_partner_id}/contact_logs',
            path: {
                care_partner_id: carePartnerId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Care Partner Contact Attempt
     * Update a care partner contact attempt.
     * Automatically logs all field changes to the audit trail.
     * @returns ContactLogResponse Successful Response
     * @throws ApiError
     */
    public static updateCarePartnerContactAttemptCarePartnerCarePartnerIdContactLogsContactAttemptIdPatch({
        carePartnerId,
        contactAttemptId,
        requestBody
    }: {
        carePartnerId: string
        contactAttemptId: string
        requestBody: CarePartnerContactLogPatch
    }): CancelablePromise<ContactLogResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/care_partner/{care_partner_id}/contact_logs/{contact_attempt_id}',
            path: {
                care_partner_id: carePartnerId,
                contact_attempt_id: contactAttemptId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
}
